import { render } from "./MailboxDetail.vue?vue&type=template&id=2e02a406"
import script from "./MailboxDetail.vue?vue&type=script&lang=js"
export * from "./MailboxDetail.vue?vue&type=script&lang=js"

import "./MailboxDetail.vue?vue&type=style&index=0&id=2e02a406&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__